module.exports = __webpack_public_path__ + "img/faq.f68a437a.svg";